<template>
  <div class="layout-wrapper d-lg-flex">
    <chat-menu />
    <chat-room />
  </div>
</template>

<script>
import {mapActions} from "vuex";
import ChatRoom from "./room";
import ChatMenu from "../components/LeftMenuComponents";
import catchDispatch from "../utils/catchDispatch";
import ServiceChat from "../services/chat";
import ServiceWebsocketsGateway from "../services/WebsocketsGateway";

export default {
  components: {
    ChatMenu,
    ChatRoom,
  },
  async mounted() {
    await Promise.all([
      this.$store.dispatch('rooms/setting'),
      this.$store.dispatch('user/fetch'),
    ]);

    try {
      ServiceChat.Init();
      ServiceWebsocketsGateway.addProvider('chat', ServiceChat);
      ServiceWebsocketsGateway.Init(this);
    } catch (e) {
      catchDispatch.call(this, e);
    }

    this.$route.params.id && this.goto({
      chat_id: this.$route.params.id,
      message_id: (
        this.$route.hash &&
        this.$route.hash.length > 1 &&
        this.$route.hash.substr(1)
      ),
    });
  },
  beforeDestroy() {
    ServiceChat.Fin();
  },
  methods: {
    ...mapActions('room', ['goto']),
  },
};
</script>

